module.exports = __webpack_public_path__ + "static/img/m_name.084e161.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/role3/lxx/m_name.png
// module id = 5FZk
// module chunks = 7